import angular from 'angular';
import { Registration } from '../model/registration';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import moment from 'moment';
import { emptyInteractionDescription } from '@/shared/components/registration/resourceApi';
import AuthService from '@/shared/services/AuthService';
import { sanitizeReferenceYear } from '@/shared/components/registration/registrationHelpers';

angular.module('cxRegistrations').directive('cxRegistrationInput', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template:
        "<div ng-include=\"'assets/templates/registrations/directives/registration'+vm.templateType+'Input.tpl.html'\"></div>",
      scope: {
        registration: '=reg',
        resources: '=?',
        trainings: '=?',
        disabled: '=?',
        settings: '=?',
        selectTraining: '&?',
      },
      bindToController: true,
      controllerAs: 'vm',
      controller: [
        '$scope',
        'resourceFactorySvc',
        'flySvc',
        'dialogsSvc',
        '$rootScope',
        'checkSecurity',
        'priceService',
        'resourceNameFilter',
        '$q',
        'appUrls',
        '$http',
        'registrationService',
        'dataCache',
        function(
          $scope,
          resourceFactorySvc,
          flySvc,
          dialogsSvc,
          $rootScope,
          checkSecurity,
          priceService,
          resourceNameFilter,
          $q,
          appUrls,
          $http,
          registrationService,
          dataCache,
        ) {
          var vm = this;
          vm.resources = [];
          vm.durationInDays = 0;
          vm.isAfternoon = false;
          vm.absenceCounter = null;
          vm.overtimeCounter = null;
          vm.maxDays = 200;
          var showError = function(error) {
            flySvc.error(error.data.code, error.data.parameters);
            return '';
          };

          vm.ckeditorOptions = {
            autoGrow_minHeight: 50,
            height: 50,
          };
          vm.$onInit = function() {
            vm.options = angular.extend(
              {
                hideFromUntil: false,
                hideDuration: false,
                hidePriceDiscount: false,
                hideBillable: false,
                hideInForfait: false,
                hideQuantity: false,
                hideRemarks: false,
                hideDate: false,
                hideInteractions: !checkSecurity('InteractionsOwn:r'),
              },
              vm.settings,
            );
          };

          var translateResources = function() {
            vm.resources = vm.resources
              .map(item => ({ ...item, name: resourceNameFilter(item), code: item.code || '' }))
              .sort(dynamicSortMultiple('code', 'name'));
          };

          var deregistration = $rootScope.$on('$translateChangeSuccess', translateResources);
          $scope.$on('$destroy', deregistration);

          vm.loadResources = function() {
            if (
              !vm.registration ||
              typeof vm.registration.type === 'undefined' ||
              vm.registration.type === null
            )
              return null;
            if (
              vm.resources != null &&
              vm.resources.length &&
              vm.resources[0].type === vm.registration.type
            )
              return null;
            return resourceFactorySvc.get('resource').reg(
              {
                type: vm.registration.type,
              },
              function(data) {
                vm.resources = data;
                translateResources();
              },
              showError,
            ).$promise;
          };
          var resourceSelected = function(retrieveOnly) {
            vm.registration.priceOptions = null;
            if (
              vm.registration.hasResource &&
              (vm.registration.resource.type === 3 ||
                vm.registration.resource.type === 4 ||
                vm.registration.resource.type === 5)
            ) {
              if (!retrieveOnly) {
                vm.registration.quantity = 0.0;
                vm.registration.price = null;
                vm.registration.amount = 0.0;
                vm.registration.discountPercentage = 0.0;
                vm.registration.isBillable = false;
                vm.registration.inForfait = null;
                vm.registration.isFixedPrice = false;
                if (vm.registration.resource.useCounter) {
                  vm.durationInDays = 1;
                  vm.durationInDaysChanged(false);
                }
                vm.retrieveAbsenceCounter();
              }
              if (vm.registration.resource.type === 4 && !retrieveOnly) {
                vm.retrieveOvertimeCounter();
              }

              var typeChanged = previousType !== null && previousType !== vm.registration.type;
              previousType = vm.registration.type;
              if (
                typeChanged &&
                (vm.durationInDays === 1 || vm.durationInDays === 2) &&
                vm.registration.durationDays > 0
              ) {
                vm.calculateDurationInDays();
              }
            } else if (vm.registration.hasResource && !vm.registration.resource.isOther) {
              // Only load price options when user has permissions
              if (checkSecurity('Pricelist:r')) {
                priceService
                  .getPrice({
                    category: vm.registration.resource.categoryId,
                    invoiceStream:
                      vm.registration.invoiceStreamId || vm.registration.relation?.invoiceStreamId,
                    user: vm.registration.userId,
                  })
                  .then(function(price) {
                    if (price) {
                      vm.registration.priceOptions = [price];
                      if (!retrieveOnly && !vm.registration.price) {
                        vm.registration.price = price;
                      }
                      if (!vm.registration.group) {
                        vm.registration.price = price;
                      }
                    }
                  });
                if (!retrieveOnly || vm.registration.inForfait === null) {
                  priceService
                    .isResourceInForfait({
                      resource: vm.registration.resource.id,
                      invoiceStream:
                        vm.registration.invoiceStreamId ||
                        vm.registration.relation?.invoiceStreamId,
                    })
                    .then(function(inForfait) {
                      vm.registration.inForfait = inForfait;
                    });
                }
              }
              if (!retrieveOnly) {
                if (
                  (vm.registration.resource.type === 1 || vm.registration.resource.type === 2) &&
                  vm.registration.quantity === 0
                )
                  vm.registration.quantity = 1;
                vm.registration.vatPercentage = vm.registration.resource.vatPercentage;
                vm.registration.vatType = vm.registration.resource.vatType;
                vm.registration.isBillable = vm.registration.resource.isBillable;
                vm.registration.isFixedPrice = vm.registration.resource.isFixedPrice;
                //if (vm.registration.type === 0 && vm.registration.durationMinutes === 0) vm.registration.durationMinute = 15; TFS 10935
              }
            } else if (!retrieveOnly) {
              vm.registration.quantity = 0.0;
              vm.registration.price = null;
              vm.registration.amount = 0.0;
              vm.registration.discountPercentage = 0.0;
              vm.registration.isBillable = true;
              vm.registration.isFixedPrice = false;
            }
          };

          vm.selectResource = function() {
            vm.registration.price = null;
            resourceSelected();
          };

          vm.selectTrainingInternal = function() {
            if (vm.selectTraining) {
              vm.selectTraining({ resources: vm.resources });
              resourceSelected();
            }
          };

          vm.calcDistance = function() {
            if (!vm.registration || vm.registration.type !== 2 || !vm.registration.relation.id)
              return;
            dialogsSvc
              .showDistanceDialog(vm.registration.relation.id, vm.registration.relation.companyId)
              .then(function(result) {
                if (result) {
                  if (result.distance) vm.registration.quantity = result.distance;
                  /*if (result.description) {
                  $scope.editReg.remark = ($scope.editReg.remark ? $scope.editReg.remark + '\n' : '') + result.description;
              }*/
                }
              });
          };

          var getTemplateType = function(type) {
            if (typeof type === 'undefined' || type === null) return 'Time';
            switch (type) {
              case 0:
                return 'Time';
              case 1:
                return 'Cost';
              case 2:
                return 'Travel';
              case 3:
                return 'Absence';
              case 4:
                return 'Recuperation';
              case 5:
                return 'Training';
              default:
                return '';
            }
          };
          vm.dateChanged = function() {
            if (
              !vm.registration.group &&
              (vm.registration.type === 0 ||
                vm.registration.type === 3 ||
                vm.registration.type === 4 ||
                vm.registration.type === 5)
            ) {
              // New registration
              if (!vm.registration.date) return;

              registrationService
                .getNextRegistrationTime(moment.utc(vm.registration.date).toDate())
                .then(function(data) {
                  if (data)
                    vm.registration.initTime(
                      data.Hour,
                      data.Minute,
                      vm.registration.durationMinutes,
                    );
                });
              vm.calculateDurationInDays();
            }
          };
          vm.durationInDaysChanged = function(calculateDurationInDays) {
            if (vm.durationInDays === 1) {
              vm.registration.durationDays = 1;
              if (calculateDurationInDays) vm.calculateDurationInDays();
            } else if (vm.durationInDays === 2) {
              vm.registration.durationDays = 0.5;
              vm.registration.isAfternoon = false;
              if (calculateDurationInDays) vm.calculateDurationInDays();
            } else {
              vm.registration.durationDays = 0;
              vm.durationDaysInfo = null;
              vm.durationDaysEndDate = null;
            }
          };

          vm.calcDurationInDaysRequest = null;
          vm.calculateDurationInDays = function() {
            if (vm.calcDurationInDaysRequest && vm.calcDurationInDaysRequest.$cancelRequest) {
              vm.calcDurationInDaysRequest.$cancelRequest();
              vm.calcDurationInDaysRequest = null;
            }
            if (!vm.durationInDays > 0) return;
            if (!vm.registration.durationDays) {
              vm.durationDaysInfo = null;
              vm.durationDaysEndDate = null;
              return;
            }

            vm.calcDurationInDaysRequest = resourceFactorySvc
              .get('registration')
              .calcDurationInDays(
                {
                  userId: vm.registration.userId,
                  date: vm.registration.date,
                  durationDays: vm.registration.durationDays,
                  isAfternoon: vm.registration.isAfternoon,
                  resourceType: vm.registration.type,
                },
                function(data) {
                  vm.durationDaysInfo = data;
                  if (data.length > 0) {
                    vm.durationDaysEndDate = data.slice(-1)[0].date;
                  } else {
                    vm.durationDaysEndDate = null;
                  }
                },
                function(error) {
                  flySvc.error(error);
                },
              );
          };

          vm.setInteractionType = function(interactionType) {
            if (vm.registration.interactionType === interactionType) {
              vm.registration.interactionType = null;
            } else {
              vm.registration.interactionType = interactionType;
            }
          };
          vm.retrieveAbsenceCounter = function() {
            vm.absenceCounter = null;
            vm.maxDays = 200;
            if (!vm.registration.resource?.useCounter) return;
            const { resource, date, userId } = vm.registration;

            var deferred = $q.defer();
            $http
              .get(`${appUrls.api}/api/AbsenceCounter/Balance`, {
                params: { resourceId: resource.id, date, userId: userId },
                timeout: deferred.promise,
                cancel: deferred,
              })
              .then(({ data }) => {
                //Check if counter was initialised
                if (
                  typeof data.balance === 'undefined' ||
                  data.balance === null ||
                  data.hoursInDay <= 0
                )
                  return;

                vm.absenceCounter = {
                  ...data,
                  balanceDays: data.balance / data.hoursInDay,
                };

                vm.maxDays = Math.max(0, vm.absenceCounter.balanceDays);
              }, showError);
            return deferred.promise;
          };

          vm.retrieveOvertimeCounter = function() {
            vm.overtimeCounter = null;
            var deferred = $q.defer();
            $http
              .get(
                `${appUrls.api}/api/Employee/MyOvertimeRemaining?userId=${vm.registration.userId}`,
                {
                  timeout: deferred.promise,
                  cancel: deferred,
                },
              )
              .then(({ data }) => {
                vm.overtimeCounter = data;
              }, showError);
            return deferred.promise;
          };

          vm.maxDuration = function() {
            if (!vm.absenceCounter) return 1439 - vm.registration.fromMinutes;
            return Math.max(
              0,
              Math.min(1439 - vm.registration.fromMinutes, vm.absenceCounter.balance * 60),
            );
          };

          var previousType = null;

          $scope.$watch(
            function() {
              return vm.registration;
            },
            function(newValue) {
              if (typeof newValue === 'undefined') return;
              if (!(vm.registration instanceof Registration)) {
                vm.registration = new Registration(vm.registration);
                retrieveInteraction();
              } else {
                retrieveInteraction();
              }

              vm.templateType = getTemplateType(vm.registration.type);

              if (vm.registration.type === 5 && !vm.registration.referenceYear) {
                vm.registration.referenceYear = sanitizeReferenceYear(null, vm.registration.date);
              }

              $q.when(vm.loadResources()).then(function() {
                if (vm.registration) {
                  resourceSelected(!!vm.registration.id);
                }
              });
            },
          );
          vm.interactionChanged = function() {
            const hasValue =
              !!vm.registration.interactionTitle ||
              vm.registration.interactionDescription !== emptyInteractionDescription;
            if (hasValue && vm.registration.interactionType === null) {
              vm.setInteractionType(0);
            } else if (!hasValue && vm.registration.interactionType !== null) {
              setInteractionType(null);
            }
          };

          var retrieveInteraction = function() {
            if (!vm.registration || !vm.registration.group || vm.registration.type !== 0) return;
            $http
              .get(appUrls.interactions + '/api/interactions/object/1/' + vm.registration.group)
              .then(
                function({ data }) {
                  if (data && data.length) {
                    const interaction = data[0];
                    vm.registration.interactionType = interaction.interactionType;
                    vm.registration.interactionDescription = interaction.description;
                    vm.registration.interactionId = interaction.id;
                    vm.registration.interactionTitle = interaction.title;
                    vm.registration.originalInteraction = interaction;
                  }
                },
                function(error) {
                  console.error(error);
                },
              );
          };
        },
      ],
    };
  },
]);
